module.exports = __webpack_public_path__ + "static/me-min-9dcdfec37a43d1b712c3dfc6513fafa1.svg";